<main
  class="event-details-container"
  [ngClass]="{ admin: isOverviewer, 'main-event-review': isPreview }"
>
  @if (!isLoading) {
    <article>
      @if (!isPreview) {
        <section class="top-name-section" [ngClass]="{ admin: isOverviewer }">
          <a class="back-button" (click)="goBack()">
            <mat-icon class="back-icon">keyboard_arrow_left</mat-icon>
            <h1 class="event-name">{{ event.eventName }}</h1>
          </a>
          @if (isOverviewer && !eventNotEditable()) {
            <section class="top-event-buttons">
              <button
                mat-flat-button
                class="cancel-button"
                (click)="cancelEvent()"
              >
                {{ ButtonAction.CANCEL_EVENT }}
              </button>
              <button
                mat-flat-button
                color="accent"
                (click)="openEditEventDialog()"
              >
                {{ ButtonAction.EDIT_EVENT }}
              </button>
            </section>
          }
        </section>
      }
      <mat-divider class="divider"></mat-divider>
      <hgroup>
        <h2 class="event-info">Event Information</h2>
        <mat-divider class="divider"></mat-divider>
      </hgroup>
      <article class="event-info-container">
        <figure class="event-photo-container">
          <figcaption class="grey-text">Event image</figcaption>
          <img [src]="eventPhotoUrl" alt="Event Photo" class="event-photo" />
          @if (isOverviewer) {
            <p class="text" (click)="openImageUpload()">Edit event image</p>
          }
        </figure>
        <section class="information-container">
          <section class="event-info">
            <section class="event-info-item">
              <p class="grey-text">Event Name</p>
              <p>{{ event.eventName }}</p>
            </section>
            <section class="event-info-item">
              <p class="grey-text">Event Type</p>
              <p>{{ event.eventType }}</p>
            </section>
            <section class="event-info-item">
              <p class="grey-text">Start date and Time</p>
              <p>{{ event.startDate | date: "HH:mm dd MMMM yyyy" }}</p>
            </section>
            <section class="event-info-item">
              <p class="grey-text">End date and Time</p>
              <p>{{ event.endDate | date: "HH:mm dd MMMM yyyy" }}</p>
            </section>
          </section>
          <section class="event-info">
            <section class="event-info-item">
              <p class="grey-text">Event description</p>
              <p>{{ event.eventDescription }}</p>
            </section>
          </section>
        </section>
      </article>
      <mat-divider class="divider"></mat-divider>
      <article>
        @for (
          eventLocation of eventLocations;
          track eventLocation;
          let index = $index
        ) {
          <section class="event-info-container">
            @if (eventLocation.location) {
              <section class="event-info">
                <section class="event-info-item">
                  <p class="grey-text">Location</p>
                  <p>{{ eventLocation.location }}</p>
                </section>
              </section>
            }
            @if (isValidAddress(eventLocation)) {
              <section class="address-info">
                <section class="address-info-item">
                  <p class="grey-text">Address Line 1</p>
                  <p>{{ getAddressLine1(eventLocation) }}</p>
                </section>
                <section class="address-info-item">
                  <p class="grey-text">Address Line 2</p>
                  <p>{{ eventLocation.address.addressLine2 }}</p>
                </section>
                <section class="address-info-item">
                  <p class="grey-text">Suburb</p>
                  <p>{{ eventLocation.address.suburb }}</p>
                </section>
                <section class="address-info-item">
                  <p class="grey-text">City</p>
                  <p>{{ eventLocation.address.city }}</p>
                </section>
                <section class="address-info-item">
                  <p class="grey-text">Postal Code</p>
                  <p>{{ eventLocation.address.code }}</p>
                </section>
              </section>
            }
            @if (isValidMeetingUrl(eventLocation)) {
              <section class="address-info">
                <section class="address-info-item">
                  <p class="grey-text">Meeting URL</p>
                  <a class="back-button">{{ eventLocation.meetingUrl }}</a>
                </section>
              </section>
            }
            @if (index < eventLocations.length - 1) {
              <mat-divider class="divider"></mat-divider>
            }
          </section>
        }
      </article>
    </article>
  }

  @if (isOverviewer) {
    @if (!isLoading) {
      <app-invitees
        [event]="event"
        [bursars]="bursars"
        [isPreview]="isPreview || eventNotEditable()"
        (newInvitees)="handleNewInvitees($event)"
        [inviteeFilters]="rsvpFilters"
      ></app-invitees>
    }
    @if (isDraftEvent()) {
      <section class="create-event-section">
        <button
          mat-flat-button
          color="primary"
          class="create-event-button"
          [disabled]="!canCreateEvent()"
          (click)="createEventFromDraft()"
        >
          {{ ButtonAction.CREATE_EVENT }}
        </button>
      </section>
    }
  }
  @if (!isOverviewer && event.rsvpDetails) {
    <mat-divider class="divider"></mat-divider>
    <section class="top-name-section rsvp-top-section">
      <h2 class="event-info">RSVP details</h2>
      @if (rsvpEditable()) {
        <button
          mat-flat-button
          color="accent"
          class="edit-rsvp"
          (click)="openRsvpDialog()"
        >
          {{ ButtonAction.EDIT_RSVP }}
        </button>
      }
    </section>
    <mat-divider class="divider"></mat-divider>
    <section class="event-info">
      <section class="event-info-item">
        <p class="grey-text">RSVP</p>
        <p>{{ event.rsvpDetails.rsvp }}</p>
      </section>
      <section class="event-info-item">
        <p class="grey-text">Attendance location</p>
        <p>{{ event.rsvpDetails.location }}</p>
      </section>
      <section class="event-info-item">
        <p class="grey-text">Dietary requirements</p>
        <p>
          {{ event.rsvpDetails.dietaryRequirements }}<br />{{
            getAllergies(event.rsvpDetails)
          }}
        </p>
      </section>
    </section>
    <section class="event-info">
      <section class="event-info-item">
        <p class="grey-text">Additional notes</p>
        <p>{{ getNotes(event.rsvpDetails) }}</p>
      </section>
    </section>
  }
</main>

<app-loader></app-loader>
